import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function PricingModelsBundling({ pricingModelsAndBundling }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     subscription_model: "b",
  //     one_time_purchase: "c",
  //     bundling_and_upsell_strategy: "d",
  //     subscription_model_positive_insight: "b",
  //     subscription_model_negative_insight: "b",
  //     subscription_model_recent_development: "b",
  //     one_time_purchase_positive_insight: "c",
  //     one_time_purchase_negative_insight: "c",
  //     one_time_purchase_recent_development: "c",
  //     bundling_and_upsell_strategy_positive_insight: "d",
  //     bundling_and_upsell_strategy_negative_insight: "d",
  //     bundling_and_upsell_strategy_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     subscription_model: "b",
  //     one_time_purchase: "c",
  //     bundling_and_upsell_strategy: "d",
  //     subscription_model_positive_insight: "b",
  //     subscription_model_negative_insight: "b",
  //     subscription_model_recent_development: "b",
  //     one_time_purchase_positive_insight: "c",
  //     one_time_purchase_negative_insight: "c",
  //     one_time_purchase_recent_development: "c",
  //     bundling_and_upsell_strategy_positive_insight: "d",
  //     bundling_and_upsell_strategy_negative_insight: "d",
  //     bundling_and_upsell_strategy_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     subscription_model: "b",
  //     one_time_purchase: "c",
  //     bundling_and_upsell_strategy: "d",
  //     subscription_model_positive_insight: "b",
  //     subscription_model_negative_insight: "b",
  //     subscription_model_recent_development: "b",
  //     one_time_purchase_positive_insight: "c",
  //     one_time_purchase_negative_insight: "c",
  //     one_time_purchase_recent_development: "c",
  //     bundling_and_upsell_strategy_positive_insight: "d",
  //     bundling_and_upsell_strategy_negative_insight: "d",
  //     bundling_and_upsell_strategy_recent_development: "d",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(pricingModelsAndBundling);
    setTabData(tableData);
  }, [pricingModelsAndBundling]);

  const tableColumns = [
    // { key: "competitor", label: "Competitor" },
    { key: "subscription_model", label: "Subscription Model" },
    { key: "one_time_purchase", label: "One-Time Purchase" },
    {
      key: "bundling_upsell_strategy",
      label: "Bundling & Upsell Strategy",
    },
  ];

  return (
    <InsightTable
      title="Pricing Models & Bundling"
      subtitle="Comparison of pricing models, bundling strategies, and value-add offerings shaping revenue generation and customer retention."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default PricingModelsBundling;
